export default __webpack_public_path__ + "static/media/chat_bubble_twitter.1d20c62d.svg";